import React, { useContext } from 'react'
import './Navbar.css'
import { NavLink } from 'react-router-dom'
import UserContext from '../context/UserContext'
import homeIcon from "../assets/home_icon_white.png"

export default function Navbar() {

  const { isAuthenticated, logout } = useContext(UserContext)

  return (
    <div className='navbarContainer'>
      <ul className='navbarList'>


        <li className='navbarListItem'>
          <NavLink to='/' activeClassName='active'>
            <img className="navbarIcon" src={homeIcon} alt="Home" />
          </NavLink>
        </li>
        <li className='navbarListItem'><NavLink to='/projects'>Projektit</NavLink></li>
        <li className='navbarListItem'><NavLink to='/contact'>Ota Yhteyttä</NavLink></li>
        {/* <li className='navbarListItem'><NavLink to='/register'>Register</NavLink></li> */}

        <div className='loginButton'>
          {!isAuthenticated ? (
            <li className='navbarListItem'><NavLink to="/login">Log In</NavLink></li>
          ) : (
            <li className='navbarListItem'>
              <NavLink onClick={logout}>Log Out</NavLink>
            </li>
          )}
        </div>

      </ul>
    </div>
  )
}
